import { create } from 'zustand';

/**
 * Signals that the taskpane should auto-generate a concept reply as soon as the
 * email context is available. Set by the InfoBar deep-link handler on startup,
 * consumed once by `useAutoGenerateConceptReply`.
 */
type PendingConceptReplyStore = {
  isPending: boolean;
  origin: Maybe<string>;
  actions: {
    request: (origin: string) => void;
    consume: () => void;
  };
};

const usePendingConceptReplyStore = create<PendingConceptReplyStore>()(
  (set) => ({
    isPending: false,
    origin: undefined,
    actions: {
      request: (origin) => set({ isPending: true, origin }),
      consume: () => set({ isPending: false, origin: undefined }),
    },
  }),
);

export default usePendingConceptReplyStore;
